import { useTranslation } from 'react-i18next'

import { Flex, TertiaryButton, Text } from '@enechain/ecloud-designsystem'
import {
  FaChevronLeftRegular,
  FaChevronRightRegular,
} from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'
import { type CivilDate } from '~/models/civilDate'

/** 日送りボタンと同じ高さ (DateStepper の CONTROL_HEIGHT)。 */
const CONTROL_HEIGHT = '40px'

type Props = {
  /** 対象月 (月の 1 日)。 */
  value: CivilDate
  onPrev: () => void
  onNext: () => void
  onThisMonth: () => void
}

/**
 * 月間の一覧の対象月の送り: [前月][2026年11月][翌月][今月]。 DateStepper (日送り) の月版で、
 * 月は 1 日の固定なので日付欄は持たず、 送りで選ぶ。
 */
export const MonthStepper = ({
  value,
  onPrev,
  onNext,
  onThisMonth,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Flex alignItems="center" gap={2}>
      <TertiaryButton
        flex="0 0 auto"
        width={CONTROL_HEIGHT}
        minWidth={CONTROL_HEIGHT}
        aria-label={t('page:splitSupplyPlan.filter.prevMonth')}
        onClick={onPrev}
        paddingX={0}
        size="md"
      >
        <FaChevronLeftRegular
          boxSize={iconSize.labeledButton}
          aria-hidden="true"
        />
      </TertiaryButton>
      <Text
        textStyle="label"
        minWidth="120px"
        textAlign="center"
        fontVariantNumeric="tabular-nums"
      >
        {t('page:splitSupplyPlan.monthLabel', {
          year: value.year,
          month: value.month,
        })}
      </Text>
      <TertiaryButton
        flex="0 0 auto"
        width={CONTROL_HEIGHT}
        minWidth={CONTROL_HEIGHT}
        aria-label={t('page:splitSupplyPlan.filter.nextMonth')}
        onClick={onNext}
        paddingX={0}
        size="md"
      >
        <FaChevronRightRegular
          boxSize={iconSize.labeledButton}
          aria-hidden="true"
        />
      </TertiaryButton>
      <TertiaryButton
        flex="0 0 auto"
        onClick={onThisMonth}
        paddingX={3}
        size="md"
      >
        {t('page:splitSupplyPlan.filter.thisMonth')}
      </TertiaryButton>
    </Flex>
  )
}
